import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Query all group series
 */
export default async function queryAllGroupSeries() {
  const res = await fetchOrchidAPI(
    "/api/scheduler/v1/group_timeslot_public/group_session_series",
  );
  if (!res.ok) {
    throw new Error(
      `failed to get group series info: ${getErrorDetail(await res.text())}`,
    );
  }

  return res.json();
}
